import { useContext, useEffect, useRef, useState } from 'react'
import { NavProvider } from '../Nav/Nav'
import { UserRole } from '../types/userRole'
import BellIcon from '../icons/BellIcon'
import { getAllClientCompanyWarehouses } from '../api'
import { ClientCompanyWarehouseData, Define, NotificationItem } from '../types'
import { genToolTip, getCountValue, getCurrentNotiCount } from './func'
import NotiDropdown from './NotiDropdown'

export default function NotiBell() {
  const {
    permission,
    account,
    notificationList = [],
    onNotiClick,
  } = useContext(NavProvider)
  const [showNotiDropdown, setShowNotiDropdown] = useState<boolean>(false)
  const [notiBadge, setNotiBadge] = useState<string>('')
  const [tooltips, setTooltips] = useState<NotificationItem[]>([])
  const { choosingClient, choosingCompany, choosingWarehouse } = account
  const role = permission.role || localStorage.getItem(Define.ROLE)
  const allStandards = useRef<Map<string, ClientCompanyWarehouseData>>(
    new Map()
  )

  const getNotiBadge = () => {
    const totalCount = notificationList.reduce((total, item) => {
      const { client_id, company_id, warehouse_id } = item
      const key = `${client_id}-${company_id}-${warehouse_id}`
      const quantity = allStandards.current.has(key) ? item.quantity : 0
      return (total += quantity)
    }, 0)

    if (role === UserRole.SUPERADMIN || !totalCount) {
      return ''
    }
    if (!choosingClient || !choosingCompany || !choosingWarehouse) {
      return getCountValue(totalCount).toString()
    }
    const currentCount = getCurrentNotiCount(
      notificationList,
      choosingClient?.id,
      choosingCompany,
      choosingWarehouse
    )

    return `${getCountValue(currentCount)}-${getCountValue(totalCount)}`
  }

  useEffect(() => {
    const notiBadge = getNotiBadge()
    setNotiBadge(notiBadge)
  }, [notificationList, choosingClient, choosingCompany, choosingWarehouse])

  useEffect(() => {
    getAllClientCompanyWarehouses()
      .then((res) => {
        const data: NotificationItem[] = res?.data?.entry
        if (data && data.length) {
          data.forEach((element) => {
            const { client_id, company_id, warehouse_id } = element
            const key = `${client_id}-${company_id}-${warehouse_id}`
            allStandards.current.set(key, element)
          })
          const notiBadge = getNotiBadge()
          setNotiBadge(notiBadge)
          const tooltips = genToolTip(notificationList, allStandards.current)
          setTooltips(tooltips)
        }
      })
      .catch((error) => {
        console.log('getAllClientCompanyWarehouses error: ', error)
      })
  }, [])

  useEffect(() => {
    const tooltips = genToolTip(notificationList, allStandards.current)
    setTooltips(tooltips)
  }, [notificationList])

  return (
    <div className="noti-bell">
      <div
        className="bell-icon"
        onMouseEnter={() => {
          setShowNotiDropdown(true)
        }}
        onClick={() => (window.location.href = '/notifications')}
      >
        <BellIcon />
      </div>
      {notiBadge && <div className="notification-badge">{notiBadge}</div>}
      {showNotiDropdown && (
        <NotiDropdown
          tooltips={tooltips}
          setShowNotiDropdown={setShowNotiDropdown}
          onNotiClick={onNotiClick}
        />
      )}
    </div>
  )
}
